<template>
<div class="service">
    <div>川航仅提供交易平台里程兑换服务</div>
    <div>缴费、技术及其他服务由相关服务方提供</div>
</div>
</template>

<script>
</script>

<style lang="less" scoped>
.service{
    text-align: center;
    line-height: 1.75;
    font-size: 12px;
    color: rgba(0,0,0,.45);
}
</style>
